import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCart$dCart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dCart$dPromotionalItem from "../Restaumatic.Cart.PromotionalItem/index.js";
import * as Restaumatic$dCart$dState$dPromotionalItem from "../Restaumatic.Cart.State.PromotionalItem/index.js";
import * as Restaumatic$dMenu$dV2$dEnv from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $$null = /* #__PURE__ */ Data$dFoldable.foldrArray(v => v1 => false)(true);
const all = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupConj1 = {append: v => v1 => v && v1};
  return {mempty: true, Semigroup0: () => semigroupConj1};
})()))();
const keyIsSymbol = {reflectSymbol: () => "key"};
const noteIsSymbol = {reflectSymbol: () => "note"};
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const couponCodeIsSymbol = {reflectSymbol: () => "couponCode"};
const extraDiscountIsSymbol = {reflectSymbol: () => "extraDiscount"};
const itemsIsSymbol = {reflectSymbol: () => "items"};
const promotionalItemsIsSymbol = {reflectSymbol: () => "promotionalItems"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const StoredProductItem = x => x;
const State = x => x;
const store = restaurantId => cart => (
  {
    restaurantId,
    items: Data$dFunctor.arrayMap(item => ({key: item.key, quantity: item.quantity, note: item.note}))(cart.products),
    promotionalItems: Restaumatic$dCart$dState$dPromotionalItem.storePromotionalItems(Data$dFunctor.arrayMap(Restaumatic$dCart$dPromotionalItem.promotionalItemEngineItem)(cart.promotionalItems)),
    couponCode: cart.couponCode,
    extraDiscount: cart.extraDiscount
  }
);
const restoreItem = menu => env => v => {
  const $0 = Restaumatic$dCart$dCart.makeProductItem(env)({key: v.key, note: v.note})(v.quantity)(menu);
  if ($0.tag === "Left") { return Data$dMaybe.Nothing; }
  if ($0.tag === "Right") { return Data$dMaybe.$Maybe("Just", $0._1); }
  $runtime.fail();
};
const restoreWithAssignmentMode = assignmentMode => menu => menuEnv => v => (
  {
    ...Restaumatic$dCart$dCart.fromProductItems(Restaumatic$dMenu$dV2$dEnv.fulfillmentMethod(menuEnv))(Restaumatic$dMenu$dV2$dEnv.paymentMethod(menuEnv))(assignmentMode)(menu)(v1 => items => {
      const $0 = v.promotionalItems.length === items.length
        ? Restaumatic$dCart$dState$dPromotionalItem.sequence(Data$dArray.zipWithImpl(Restaumatic$dCart$dState$dPromotionalItem.updateItem, v.promotionalItems, items))
        : Data$dMaybe.Nothing;
      if ($0.tag === "Nothing") { return items; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    })(Data$dArray.mapMaybe(restoreItem(menu)(menuEnv))(v.items))(v.couponCode),
    extraDiscount: v.extraDiscount
  }
);
const restoreManualAssign = /* #__PURE__ */ restoreWithAssignmentMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.ManualAssign);
const restore = /* #__PURE__ */ restoreWithAssignmentMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign);
const readCouponCode = v => v.couponCode;
const newtypeStoredProductItem = {Coercible0: () => {}};
const newtypeState = {Coercible0: () => {}};
const isEmpty = v => (() => {
  if (v.couponCode.tag === "Nothing") { return true; }
  if (v.couponCode.tag === "Just") { return false; }
  $runtime.fail();
})() && ($$null(v.items) || all(x => x.quantity === 0)(v.items));
const genericStoredProductItem = {to: x => x, from: x => x};
const showStoredProductItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ key: " + Restaumatic$dCart$dProductKey.showProductKey.show(v.key) + ", note: " + showMaybe.show(v.note) + ", quantity: " + Data$dShow.showIntImpl(v.quantity) + " " + "}"
      ]
    })({reflectSymbol: () => "StoredProductItem"});
    return x => $0["genericShow'"](x);
  })()
};
const genericState = {to: x => x, from: x => x};
const showState = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dCart$dState$dPromotionalItem.showStoredPromotionalItem.show);
      const $1 = Data$dShow.showArrayImpl(showStoredProductItem.show);
      return {
        genericShowArgs: v => [
          "{ couponCode: " + showMaybe.show(v.couponCode) + (() => {
            if (v.extraDiscount.tag === "Just") {
              return ", extraDiscount: (Just " + Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.showExtraDiscount.show(v.extraDiscount._1) + ")" + ", items: " + $1(v.items) + ", promotionalItems: " + $0(v.promotionalItems) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " ";
            }
            if (v.extraDiscount.tag === "Nothing") {
              return ", extraDiscount: Nothing, items: " + $1(v.items) + ", promotionalItems: " + $0(v.promotionalItems) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " ";
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())({reflectSymbol: () => "State"});
    return x => $0["genericShow'"](x);
  })()
};
const eqStoredProductItem = {
  eq: x => y => Restaumatic$dCart$dProductKey.eqProductKey.eq(x.key)(y.key) && (() => {
    if (x.note.tag === "Nothing") { return y.note.tag === "Nothing"; }
    if (x.note.tag === "Just") {
      if (y.note.tag === "Just") { return x.note._1 === y.note._1; }
      return false;
    }
    return false;
  })() && x.quantity === y.quantity
};
const eqState = {
  eq: /* #__PURE__ */ (() => {
    const $0 = Data$dEq.eqArrayImpl(Restaumatic$dCart$dState$dPromotionalItem.eqStoredPromotionalItem.eq);
    const $1 = Data$dEq.eqArrayImpl(eqStoredProductItem.eq);
    return x => y => (() => {
      if (x.couponCode.tag === "Nothing") { return y.couponCode.tag === "Nothing"; }
      if (x.couponCode.tag === "Just") {
        if (y.couponCode.tag === "Just") { return x.couponCode._1 === y.couponCode._1; }
        return false;
      }
      return false;
    })() && (() => {
      if (x.extraDiscount.tag === "Nothing") { return y.extraDiscount.tag === "Nothing"; }
      if (x.extraDiscount.tag === "Just") {
        if (y.extraDiscount.tag === "Just") {
          return x.extraDiscount._1.name === y.extraDiscount._1.name && (() => {
            if (x.extraDiscount._1.prize.tag === "PriceDiscount") {
              if (y.extraDiscount._1.prize.tag === "PriceDiscount") { return x.extraDiscount._1.prize._1 === y.extraDiscount._1.prize._1; }
              return false;
            }
            if (x.extraDiscount._1.prize.tag === "PercentageDiscount") {
              if (y.extraDiscount._1.prize.tag === "PercentageDiscount") { return x.extraDiscount._1.prize._1 === y.extraDiscount._1.prize._1; }
              return false;
            }
            return false;
          })();
        }
        return false;
      }
      return false;
    })() && $1(x.items)(y.items) && $0(x.promotionalItems)(y.promotionalItems) && x.restaurantId === y.restaurantId;
  })()
};
const encodeStoredProductItem = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(quantityIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(noteIsSymbol)(encodeWithOptionsOther))(keyIsSymbol)({encodeWithOptions: v => Restaumatic$dCart$dProductKey.encodeProductKey.encode}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const encodeState = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(promotionalItemsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dCart$dState$dPromotionalItem.encodeStoredPromotionalItem.encode);
      return {encodeWithOptions: v => encode1};
    })()))(itemsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeStoredProductItem.encode);
      return {encodeWithOptions: v => encode1};
    })()))(extraDiscountIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.encodeExtraDiscount.encode(v2._1); }
        $runtime.fail();
      }
    }))(couponCodeIsSymbol)(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const decodeStoredProductItem = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(quantityIsSymbol)({
      decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
    })())(noteIsSymbol)(decodeWithOptionsOther)())(keyIsSymbol)({decodeWithOptions: v => Restaumatic$dCart$dProductKey.decodeProductKey.decode})()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
const decodeState = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)({
      decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
    })())(promotionalItemsIsSymbol)((() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dCart$dState$dPromotionalItem.decodeStoredPromotionalItem).decode;
      return {decodeWithOptions: v => decode2};
    })())())(itemsIsSymbol)((() => {
      const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeStoredProductItem).decode;
      return {decodeWithOptions: v => decode2};
    })())())(extraDiscountIsSymbol)({
      decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.decodeExtraDiscount.decode)
    })())(couponCodeIsSymbol)(decodeWithOptionsOther)()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  }
))();
export {
  State,
  StoredProductItem,
  all,
  couponCodeIsSymbol,
  decodeState,
  decodeStoredProductItem,
  decodeWithOptionsOther,
  encodeState,
  encodeStoredProductItem,
  encodeWithOptionsOther,
  eqState,
  eqStoredProductItem,
  extraDiscountIsSymbol,
  genericState,
  genericStoredProductItem,
  isEmpty,
  itemsIsSymbol,
  keyIsSymbol,
  newtypeState,
  newtypeStoredProductItem,
  noteIsSymbol,
  $$null as null,
  promotionalItemsIsSymbol,
  quantityIsSymbol,
  readCouponCode,
  restaurantIdIsSymbol,
  restore,
  restoreItem,
  restoreManualAssign,
  restoreWithAssignmentMode,
  showMaybe,
  showState,
  showStoredProductItem,
  store
};
